<template>
  <!-- Languages -->
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn class="mr-3" outlined v-on="on">
        <span
          :class="
            `flag-icon flag-icon-${selectedLanguage.flag.toLowerCase()} mr-3`
          "
        />
        {{ selectedLanguage.title }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in languages"
        :key="index"
        :dense="small"
        selected
        @click="setLanguage(item)"
      >
        <v-list-item-title>
          <span
            :class="`flag-icon flag-icon-${item.flag.toLowerCase()} mr-3`"
          ></span>
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'LanguagesMenu',
  props: {
    small: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['languages', 'selectedLanguage'])
  },
  methods: {
    ...mapMutations('app', ['setSelectedLanguage']),
    setLanguage(value) {
      // Add language code to localStorage as 'locale'
      localStorage.setItem('locale', JSON.stringify(value))
      this.setSelectedLanguage(value)
    }
  }
}
</script>
